import React from 'react';
import { CtaButton } from './CtaButton';
import { MegapackMockup } from './MegapackMockup';
import { price } from '../../data/landing';
export function FinalCta() {
  return <section aria-labelledby="final-title" className="bg-primary-dark py-16 text-cream md:py-24" data-id="element-77" data-mp="brfe098s0ovt">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16" data-id="element-78" data-mp="7pu5t176syry">
        <div className="text-center lg:text-left" data-id="element-79" data-mp="3g5nc6n7t0tva">
          <h2 id="final-title" className="font-serif text-[2.3rem] leading-[1.05] md:text-6xl" data-id="element-80" data-mp="3g6f9c2h1uzno">
            Dejá de preguntarte <em className="text-[#F2C9AE]" data-id="element-81" data-mp="3b8dopd3z6sa3">“¿qué actividad uso hoy?”</em>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-cream/80 lg:mx-0" data-id="element-82" data-mp="3oziivzokqsd1">
            6 tomos organizados por objetivo terapéutico y 5 bonos para que llegues a cada sesión con el material
            listo.
          </p>
          <div className="mt-9 flex flex-col items-center lg:items-start" data-id="element-83" data-mp="2sg1c7xjlyam8">
            <CtaButton variant="light" data-id="element-84" data-mp="2sdyqhpphn3nb">Quiero tener mis sesiones resueltas</CtaButton>
            <p className="mt-4 text-sm text-cream/75" data-id="element-85" data-mp="nigtxoj5wtki">
              <strong className="font-bold text-cream" data-id="element-86" data-mp="shl34f636rau">{price}</strong> · Descarga inmediata · 7 días de garantía
            </p>
          </div>
        </div>
        <MegapackMockup showBadge={false} data-id="element-87" data-mp="xawe8shxlu8k" />
      </div>
    </section>;
}